import axios from "axios";
const REACT_APP_ADMIN_API = process.env.REACT_APP_ADMIN_API;

export const getTransformations = async (query, page = 1, cancelToken) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_ADMIN_API}/api/transformation?db=${region}&q=${query}&results_per_page=200`,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const getTransformation = async (transformationName) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_ADMIN_API}/api/transformation/${transformationName}?db=${region}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data,
    };
  } catch (e) {
    return { e };
  }
};

export const editTransformation = async (
  transformationName,
  tags,
  transformation,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  const response = await axios({
    method: "put",
    url: `${REACT_APP_ADMIN_API}/api/transformation/${transformationName}?db=${region}`,
    headers: { Authorization: `Bearer ${token}` },
    data: {
      tags,
      transformation,
    },
  });
  return {
    data: response.data,
  };
};

export const createTransformation = async (
  transformationName,
  tags,
  transformation,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  const response = await axios({
    method: "post",
    url: `${REACT_APP_ADMIN_API}/api/transformation?db=${region}`,
    headers: { Authorization: `Bearer ${token}` },
    data: {
      name: transformationName,
      tags,
      transformation,
    },
  });
  return {
    data: response.data,
  };
};

export const deleteTransformation = async (transformationName) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  const response = await axios({
    method: "delete",
    url: `${REACT_APP_ADMIN_API}/api/transformation/${transformationName}?db=${region}`,
    headers: { Authorization: `Bearer ${token}` },
  });
  return {
    data: response.data,
  };
};
